module.exports = __webpack_public_path__ + "static/media/read_app.0dc8b9ff.png";